import { useState, useEffect, useContext } from "react";

import ProductContext from "context/ProductContext/ProductDataContext";

import useAxios from "services/useAxios.tsx";

import Pagination from "rc-pagination";
import { Helmet } from "react-helmet";

import ProductCardCat from "Components/Pages/MobileAccesories/ProductCardCat";
import Loader from "../Components/kits/Loader/Loader.tsx";

import "../Components/Pages/MobileAccesories/mobileacc.css";
import Authentication from "../context/Authentication/AuthenticationContext.ts";
export default function DiscountProduct() {
  const auth = useContext(Authentication);
  const { execute: getProduct } = useAxios("api3/filterproducts");

  const { setProductUpdater } = useContext(ProductContext);

  const [product, setProduct] = useState([]);
  const [loader, setLoader] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  let timeDiscount = Math.floor(new Date().getTime() / 1000 + 86400);

  useEffect(() => {
    getProduct({
      discount_tm: timeDiscount,
      search: "1",
      ...(auth?.userInfo?.userType == "0" && { all: "1" }),
    })
      .then((result) => {
        setProduct(result.products);
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.e("err: ", err);
      });
  }, []);
  console.log("product", product);
  return loader ? (
    <div className="w-100 pd-t-100 d-flex justify-content-center align-items-center">
      <Loader />
    </div>
  ) : (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>پیشنهاد شگفت انگیز</title>
      </Helmet>
      <div className="mobile_accessories">
        <div className="mobile-accessories-box">
          <div className="d-flex flex-wrap">
            {product
              ?.slice((currentPage - 1) * 24, (currentPage - 1) * 24 + 24)
              .map((value) => {
                return (
                  <ProductCardCat
                    productData={value}
                    setUpdater={setProductUpdater}
                    isHashtag={true}
                    isCategory={true}
                  />
                );
              })}
          </div>
        </div>
      </div>
      {product.length > 1 && (
        <div className="d-flex justify-content-center my-4 ">
          <Pagination
            showTitle={false}
            className="mx-1"
            total={product.length}
            pageSize={24}
            current={currentPage}
            onChange={(newPage) => {
              setCurrentPage(newPage);
            }}
          />
        </div>
      )}
    </div>
  );
}
